import React, { useEffect } from 'react';
import {connect, useSelector} from 'react-redux'

// component
import AfiClassList from "./_list";
import { showLoader } from "../../../components/loader/loader";

// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";
import {getStateByPath} from "../../../redux/selectors";

const AfiClass = props => {
    const path = "hotel/afiClass";
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

        useEffect(() => {   
            if (props.app !== null)
                props.setApp(path, props.app);
        },[]);

    return <>
        {loading && showLoader()}
        { componentState && <AfiClassList path={path} /> }
    </>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setUserIsAdmin,
});

export default connect(mapStateToProps, mapActionsToProps)(AfiClass)